<template>
  <div class="impact-stat-card" :style="{ backgroundColor: bgColor }">
    <div class="d-flex align-center mb-3" style="gap: 8px">
      <v-icon size="24" :color="color">{{ icon }}</v-icon>
      <Typography variant="body-1" class="text-left" :style="{ color }">{{ label }}</Typography>
    </div>
    <div
      v-for="(row, i) in rows"
      :key="i"
      class="d-flex align-center justify-center mb-2"
      style="gap: 12px"
    >
      <Typography
        v-if="row.label"
        variant="body-2"
        class="dagrey--text"
        style="min-width: 110px; text-align: right"
        >{{ row.label }} :
      </Typography>
      <Typography variant="h-5">{{ row.remove }}</Typography>
      <Typography variant="h-5">+</Typography>
      <Typography variant="h-5">{{ row.keep }}</Typography>
      <Typography variant="h-5">=</Typography>
      <Typography variant="h-5" :style="{ color }">{{ row.combined }}</Typography>
    </div>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";

export default {
  name: "ImpactStatCard",
  components: { Typography },
  props: {
    icon: { type: String, required: true },
    color: { type: String, required: true },
    bgColor: { type: String, required: true },
    label: { type: String, required: true },
    // Each row: { label?, remove, keep, combined }
    rows: { type: Array, required: true },
  },
};
</script>

<style scoped>
.impact-stat-card {
  border-radius: 8px;
  padding: 24px;
}
</style>
